import { Group, Paper, SimpleGrid, Stack, Text } from "@mantine/core";

export function StatsCard({ data, cols }) {
  return (
    <SimpleGrid
      cols={cols}
      breakpoints={[
        { maxWidth: "1500", cols: 2 },
        { maxWidth: "md", cols: 2 },
        { maxWidth: "sm", cols: 1 },
      ]}
    >
      {data.map((stat, index) => {
        return (
          <Paper
            p="xl"
            withBorder
            radius="md"
            key={index}
            style={{
              backgroundColor: stat.color || "#DC143C",
            }}
          >
            <Stack align="center">
              <Text size={30} color="white">
                {stat.title}
              </Text>

              <Text
                px="xs"
                weight="bold"
                size={50}
                align="center"
                color="white"
              >
                {stat.value}
              </Text>
            </Stack>
          </Paper>
        );
      })}
    </SimpleGrid>
  );
}
